import React from 'react';
import styles from './content-selector.module.scss';

const ContentDataSelector = (
  {
    data,
    onDataSelected,
    labelStyle,
    elementContainerClass,
    containerClassName,
    searchString,
    noResultsString,
    noResultsStringStyle
  }: {
    data: any,
    onDataSelected: any,
    labelStyle?: any,
    elementContainerClass?: any,
    containerClassName?: any,
      searchString?: any
      noResultsString?: any
      noResultsStringStyle?: any
  }
) => {

  const filteredData = (searchString && searchString.trim() !== "" && searchString.length > 0) ? data.filter((dataElement: any) => dataElement.label.toLowerCase().includes(searchString.toLowerCase())) : data;
  return (
    <div
      className={`${styles.contentSelector__container} ${containerClassName ? containerClassName : ''}`}
    >{
        filteredData.length > 0 ?
          <>
            {filteredData.map((dataElement: any, index: any) => (
              <div
                key={index}
                className={`${styles.contentSelector__element__container} ${elementContainerClass ? ` ${elementContainerClass}` : ''}`}
                onClick={() => onDataSelected(dataElement.value, dataElement)}
              >
                <p
                  className={`${styles.contentSelector__element__label} ${labelStyle ? labelStyle : ''}`}
                >
                  {dataElement.label}
                </p>
              </div>
            ))
            }
          </>
          :
          <h1 className={`${styles.contentSelector__noResults} ${noResultsStringStyle ? noResultsStringStyle : ''}`}>{noResultsString ? noResultsString : 'No results found' }</h1>

      }
    </div>
  )
}

export default ContentDataSelector